import type {
  FilterDefinition,
  SortOptionDefinition,
  TechnologyFilterExtraInfo
} from '@/domain/FilteringAndSorting';
import options from './options.json';
import translations from './translations.json';

export { default as defaultFilters } from './defaultFilters.json';
export { default as defaultSortOptions } from './defaultSortOptions.json';
export { default as defaultPromotionCards } from './defaultPromotionCards.json';

type SimpleOptions = typeof options;
export type Options = SimpleOptions & {
  filters: FilterDefinition[];
  sortOptions: SortOptionDefinition[];
  technologyInfo: TechnologyFilterExtraInfo;
  promotionCards: PromotionCardDefinition[];
  /**
   * @deprecated - Moved to AB testing (it exists for backward compatibility)
   */
  enableStickyFilters: boolean;
  hideAppliedFilters: boolean;
  displayTechnologyLabelOnProductCards: boolean;
  displayNewAddToBagButton: boolean;
  displayFavoriteButton: boolean;
};
export const defaultOptions = options;

export type Translations = typeof translations;
export const defaultTranslations = translations;

export type PromotionCardDefinition = {
  promotionId: string;
  promotionName: string;
  promotionCreative: string;
  categoryId: string;
  placement: 'before' | 'after';
  productId?: string;
  title: string;
  description: string;
  backgroundImage: string;
  backgroundTheme: 'light' | 'dark';
  backgroundOverlay: 'full' | 'top' | 'bottom' | 'none';
  disableHoverEffect?: boolean;
  cta?: {
    type?: 'modal' | 'link';
    label: string;
    url: string;
    target?: 'same-tab' | 'new-tab';
    buttonPosition: 'left' | 'right' | 'center';
  };
  modal?: {
    heading: string;
    images: {
      desktopImage: string;
      tabletImage: string;
      mobileImage: string;
    };
    imageAlt: string;
    copy: string;
    disclaimerText: string;
  };
};

export const alternativesItemListName = 'Alternatives';
